$(document).ready(function() {
    $(document).on('click', "a[class^='delete_ad']", function (e) {
        e.preventDefault();
        let elem = $(this);
        var ad_unique_id = $(this).data('ad_unique_id');
        UIkit.modal.confirm('Вы уверены?', {labels: {ok: 'Да', cancel: 'Отмена'}}).then(function () {
            $.ajax({
                url: '/sale/api/',
                type: 'POST',
                data: {action: 'delete_ad', data: {'ad_unique_id': ad_unique_id}},
                dataType: 'json',
                success: function(response) {
                    console.log(response);
                    if (response) {
                        if (response.status == 'success') {
                            ym(51382882, 'reachGoal', 'Delete classified');
                            $(elem).closest('.classified_item').remove();
                            if ($('.classified_item').length == 0) {
                                $('#my_classifieds').append('<p>Чтобы опубликовать объявление, перейдите в раздел «<a href="/sale/new/">Создать объявление</a>».</p>');
                            }
                        } else if (response.status == 'postponed') {
                            ym(51382882, 'reachGoal', 'Postponed delete classified');
                        }
                        UIkit.modal.alert(`<p>${response.message}</p>`).then(function() {
                            location.reload();
                        });
                    } else {
                        UIkit.modal.alert('<p>Ошибка.</p>');
                    }
                }
            });
        }, function () {

        });
    });
});